"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Range converter
 *
 * @author RV
 */


var RangeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(RangeConverter, _DataObjectConverter_);

  function RangeConverter() {
    _classCallCheck(this, RangeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(RangeConverter).apply(this, arguments));
  }

  return RangeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.RangeConverter = RangeConverter;